import { qualificationScore, type Qualification } from '@/types/crm'
import { QUALIFICATION_CRITERIA, scoreStyle } from '../qualification'

/**
 * The scorecard as shown in the drawer — read-only, editing happens in the
 * modal. Three segments rather than a number alone, because a rep comparing two
 * leads reads the bar faster than the digit.
 */
export function QualificationCard({
  qualification,
  onEdit,
}: {
  qualification: Qualification
  onEdit: () => void
}) {
  const score = qualificationScore(qualification)
  const style = scoreStyle(score)

  return (
    <section className="card qual">
      <div className="qual__head">
        <div className="card-label">Lead qualification</div>
        <div className="qual__headright">
          <span className="pill" style={{ background: style.bg, color: style.color }}>
            {style.label} · {score}/3
          </span>
          <button className="btn-mini" onClick={onEdit}>
            Edit
          </button>
        </div>
      </div>

      <div className="qual__bar" role="img" aria-label={`Score ${score} of 3`}>
        {[0, 1, 2].map((i) => (
          <div
            key={i}
            className="qual__seg"
            style={{ background: i < score ? style.color : 'var(--color-border-subtle)' }}
          />
        ))}
      </div>

      <div className="qual__criteria">
        {QUALIFICATION_CRITERIA.map((c) => {
          const met = qualification[c.key]
          return (
            <div key={c.key} className="qual__criterion">
              <span
                className="qual__mark"
                style={{ color: met ? 'var(--color-success)' : 'var(--color-grey)' }}
                aria-hidden="true"
              >
                {met ? '✓' : '✗'}
              </span>
              <span>
                {c.label} — {c.hint}
              </span>
            </div>
          )
        })}
      </div>

      {qualification.comment && <div className="qual__comment">“{qualification.comment}”</div>}
    </section>
  )
}
